export default __webpack_public_path__ + "static/media/BOOK 56670 - Barra de carga stacker 1.62539552.pdf";